import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import LoginScreen from './pages/login-screen';
import ResetPassword from "./pages/login-screen/ResetPassword";
import ManagerDashboard from './pages/manager-dashboard';
import ProgressReports from './pages/progress-reports';
import SyllabusContentViewer from './pages/syllabus-content-viewer';
import InterviewScheduling from './pages/interview-scheduling';
import TraineeDashboard from './pages/trainee-dashboard';
import AssessmentEntry from './pages/assessment-entry';
import UploadSyllabus from "./pages/manager-dashboard/components/UploadSyllabus";
import TraineeStepsPage from "./pages/manager-dashboard/components/TraineeStepsPage";
import DepartmentPage from "./pages/manager-dashboard/components/DepartmentPage";
import AssignDepartmentPage from "./pages/manager-dashboard/components/AssignDepartmentPage";
import TraineeSyllabusPage from "./pages/manager-dashboard/components/TraineeSyllabusPage";
import TrainingSessions from "./pages/training-sessions";
import TaskManagement from "./pages/task-management";
import MyTasks from "./pages/my-tasks";
import QuizManagement from "./pages/quiz-management";
import MyQuizzes from "./pages/my-quizzes";
import TypingManagement from "./pages/typing-management";
import MyTyping from "./pages/my-typing";
import VideoManagement from "./pages/video-management";
import MyVideos from "./pages/my-videos";
import BatchManagement from "./pages/batch-management";
import DeviceManagement from "./pages/device-management";
import MacGate from "./components/MacGate";
import SsoGate from "./components/SsoGate";


const ProtectedRoute = ({ allowedRoles, children }) => {
  const role = sessionStorage.getItem("userRole");

  if (!role) {
    console.log("sd", role)
    return <Navigate to="/login-screen" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/*" replace />;
  }

  return children;
};


const NotAuthorized = () => (
  <div className="h-screen flex items-center justify-center text-xl font-semibold">
    ❌ You are not authorized to access this page
  </div>
);

const Routes = () => {
  return (
    <MacGate>
    <SsoGate>
    <BrowserRouter>
      <RouterRoutes>

        {/* Public Routes */}
        <Route path="/" element={<LoginScreen />} />
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Manager Only */}
        <Route
          path="/manager-dashboard"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <ManagerDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/upload-syllabus"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <UploadSyllabus />
            </ProtectedRoute>
          }
        />

        <Route
          path="/trainee-steps"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <TraineeStepsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/interview-scheduling"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <InterviewScheduling />
            </ProtectedRoute>
          }
        />



<Route
          path="/department"
          element={
            //<ProtectedRoute allowedRoles={["MANAGER"]}>
              <DepartmentPage />
            //</ProtectedRoute>
          }
        />

        <Route
          path="/assign-trainee"
          element={
            //<ProtectedRoute allowedRoles={["MANAGER"]}>
              <AssignDepartmentPage/>
            //</ProtectedRoute>
          }
        />
        <Route
          path="/assessment-entry"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <AssessmentEntry />
            </ProtectedRoute>
          }
        />
        <Route
          path="/training-sessions"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <TrainingSessions />
            </ProtectedRoute>
          }
        />
        <Route
        
          path="/trainee-syllabus/:traineeId"
          element={
             <ProtectedRoute allowedRoles={["MANAGER"]}>
          <TraineeSyllabusPage />
          </ProtectedRoute>
        }
        />

        {/* Trainee Only */}
        <Route
          path="/trainee-dashboard"
          element={
            <ProtectedRoute allowedRoles={["TRAINEE"]}>
              <TraineeDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/syllabus-content-viewer"
          element={
            <ProtectedRoute allowedRoles={["TRAINEE"]}>
              <SyllabusContentViewer />
            </ProtectedRoute>
          }
        />

        {/* Task Management */}
        <Route
          path="/task-management"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <TaskManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-tasks"
          element={
            <ProtectedRoute allowedRoles={["TRAINEE"]}>
              <MyTasks />
            </ProtectedRoute>
          }
        />

        {/* Quiz / Assessment */}
        <Route
          path="/quiz-management"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <QuizManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-quizzes"
          element={
            <ProtectedRoute allowedRoles={["TRAINEE"]}>
              <MyQuizzes />
            </ProtectedRoute>
          }
        />

        {/* Typing Speed Test */}
        <Route
          path="/typing-management"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <TypingManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-typing"
          element={
            <ProtectedRoute allowedRoles={["TRAINEE"]}>
              <MyTyping />
            </ProtectedRoute>
          }
        />

        {/* Batch Management */}
        <Route
          path="/batch-management"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <BatchManagement />
            </ProtectedRoute>
          }
        />

        {/* Device Management (approved-device allow-list; page itself gates to CEO/CTO/HR) */}
        <Route
          path="/device-management"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <DeviceManagement />
            </ProtectedRoute>
          }
        />

        {/* Video Lessons */}
        <Route
          path="/video-management"
          element={
            <ProtectedRoute allowedRoles={["MANAGER"]}>
              <VideoManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-videos"
          element={
            <ProtectedRoute allowedRoles={["TRAINEE"]}>
              <MyVideos />
            </ProtectedRoute>
          }
        />

        {/* System Routes */}
        <Route path="/not-authorized" element={<NotAuthorized />} />
        <Route path="*" element={<NotFound />} />

      </RouterRoutes>
    </BrowserRouter>
    </SsoGate>
    </MacGate>
  );
};

// const Routes = () => {
//   return (
//     <BrowserRouter>
//       {/* <ErrorBoundary> */}
//       {/* <ScrollToTop /> */}
//       <RouterRoutes>
//         {/* Define your route here */}
//         <Route path="/" element={<LoginScreen />} />
//         <Route path="/login-screen" element={<LoginScreen />} />
//         <Route path="/manager-dashboard" element={<ManagerDashboard />} />
//         <Route path="/progress-reports" element={<ProgressReports />} />
//         <Route path="/syllabus-content-viewer" element={<SyllabusContentViewer />} />
//         <Route path="/interview-scheduling" element={<InterviewScheduling />} />
//         <Route path="/trainee-dashboard" element={<TraineeDashboard />} />
//         <Route path="/assessment-entry" element={<AssessmentEntry />} />
//         <Route path="/upload-syllabus" element={<UploadSyllabus />} />
//         <Route path="/trainee-steps" element={<TraineeStepsPage />} />
//         <Route path="/reset-password" element={<ResetPassword />} />


//         <Route path="/progress-reports/:traineeId" element={<ProgressReports />} />
//         <Route path="*" element={<NotFound />} />
//       </RouterRoutes>
//       {/* </ErrorBoundary> */}
//     </BrowserRouter>
//   );
// };

export default Routes;
